import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  item: {
    marginTop: pxToRem(30),
    marginBottom: pxToRem(30),
  },
});
